import type { PaginationProps } from 'antd';
import classes from './index.module.scss';

export interface MyTablePaginationProps extends Omit<PaginationProps, 'className'> {
  className?: ClassNames;
  paginationClassName?: ClassNames;
}

export default function MyTablePagination({
  className,
  paginationClassName,
  ...props
}: MyTablePaginationProps) {
  return (
    <Pagination
      rootClassName={cls(classes.myTablePagination, className)}
      align="center"
      showSizeChanger
      {...props}
    />
  );
}
